class AllActionTypes {
    //for loader
    static LOADER_STATE_TRUE = 'LOADER_STATE_TRUE';
    static LOADER_STATE_FALSE = 'LOADER_STATE_FALSE';
    static HANDLE_LEFT = 'HANDLE_LEFT';
    static ACTIVE_LINK = 'ACTIVE_LINK';
    static CLEAR_DATA = 'CLEAR_DATA';
    static ROLE_PERMISSION = 'ROLE_PERMISSION';
    static CONNECT_DISCONNECT_TO_WEBSOCKET = 'CONNECT_DISCONNECT_TO_WEBSOCKET';
    static LOCK_FLAG = 'LOCK_FLAG';
    static PLANNING_EDITABLE_BEFORE_CURRENT_DAY = 'PLANNING_EDITABLE_BEFORE_CURRENT_DAY';
    /* Changes for PM-189 */
    static SET_INVENTORY_BRANCH = 'SET_INVENTORY_BRANCH';
    static SET_INVENTORY_BRANCHES = 'SET_INVENTORY_BRANCHES';
    /* Global Branch Controller (Dashboard as source of truth) */
    static SET_GLOBAL_BRANCHES = 'SET_GLOBAL_BRANCHES';
    static SET_DASHBOARD_BRANCH = 'SET_DASHBOARD_BRANCH';
    static SET_MODULE_BRANCH = 'SET_MODULE_BRANCH';
}
export default AllActionTypes;